import * as React from 'react';
import { UIHeading2, UIText1, Button, Responsive } from '@cian/ui-kit';

import * as style from './Success.css';
import { Link } from '../../Link';

export interface INewReviewModalSuccessProps {
  type: string;
  url: string;
  close(): void;
}

export const Success: React.FC<INewReviewModalSuccessProps> = props => {
  const { url, close, type } = props;

  return (
    <div data-testid="Success" data-name="Success" className={style['container']}>
      <div className={style['content']}>
        <div className={style['header']}>
          <UIHeading2>Спасибо!</UIHeading2>
        </div>
        <div className={style['text']}>
          <UIText1>
            После <Link url={url}>модерации</Link> ваш {type} <br /> появится на странице ЖК
          </UIText1>
        </div>
        <div className={style['action']}>
          <Responsive desktop tablet>
            <Button size="XS" onClick={close}>
              Закрыть
            </Button>
          </Responsive>
          <Responsive phone>
            <Button size="M" onClick={close}>
              Закрыть
            </Button>
          </Responsive>
        </div>
      </div>
    </div>
  );
};
